import { Col, Input, Row } from "antd";

import Background from "@components/background";
import { Contain } from "@components/layout";

interface SearchHeaderProps {
  className: string;
  defaultValue?: string | undefined;
  onSearch?: any;
  children?: any;
  loading?: boolean;
  imgSrc?: string;
  style?: any;
}

const defaultProps: SearchHeaderProps = {
  className: "",
  imgSrc:  "https://covrprice.com/wp-content/themes/covr/assets/images/bg-artboard-05.png",
};

const { Search } = Input;

const SearchHeader = ({
  defaultValue,
  className,
  imgSrc,
  style,
  onSearch,
  loading,
  children,
}: SearchHeaderProps) => {
  return (
    <Background
      className={`covr-search-header bg-image bg-cover ${className}`}
      src={imgSrc}
    >
      <Contain className={'covr-search-header-container'} >
        <Row
          justify="center"
          align="middle"
          className={'covr-search-header-row'}
        >
          <Col span={18}>
            <Search
              loading={loading}
              placeholder="SEARCH BY COMIC TITLE"
              enterButton="GO"
              size="large"
              onSearch={onSearch}
              defaultValue={defaultValue}
            />
            <p className={'text-white'}># to Search for Issues</p>
          </Col>
        </Row>
        {children}
      </Contain>
    </Background>
  );
};

SearchHeader.defaultProps = defaultProps;

export default SearchHeader;
